import React, { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import { useToast } from '../hooks/use-toast';
import { submitQuote } from '../lib/api';

const QuoteModal = ({ open, onOpenChange, product }) => {
  const { toast } = useToast();
  const [form, setForm] = useState({ name: '', email: '', phone: '', notes: '' });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) {
      toast({ title: 'Missing info', description: 'Please provide your name and email.' });
      return;
    }
    setLoading(true);
    try {
      await submitQuote({
        name: form.name,
        email: form.email,
        phone: form.phone,
        product_name: product?.name || '',
        product_price: product?.price || '',
        notes: form.notes,
      });
      toast({ title: 'Quote requested!', description: `We'll email you a quote for the ${product?.name} shortly.` });
      setForm({ name: '', email: '', phone: '', notes: '' });
      onOpenChange(false);
    } catch (err) {
      toast({ title: 'Something went wrong', description: 'Please try again in a moment.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="font-heading">Request a Quote</DialogTitle>
          <DialogDescription>
            {product ? `Get pricing details for the ${product.name} (${product.price}).` : 'Get pricing details.'}
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 pt-2">
          <div className="space-y-2">
            <Label htmlFor="q-name">Full Name</Label>
            <Input id="q-name" name="name" value={form.name} onChange={handleChange} placeholder="John Doe" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="q-email">Email</Label>
            <Input id="q-email" name="email" type="email" value={form.email} onChange={handleChange} placeholder="you@example.com" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="q-phone">Phone (optional)</Label>
            <Input id="q-phone" name="phone" value={form.phone} onChange={handleChange} placeholder="(905) 909-7555" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="q-notes">Notes (optional)</Label>
            <Textarea id="q-notes" name="notes" value={form.notes} onChange={handleChange} rows={3} placeholder="Any customization or questions?" className="resize-none" />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-blue-600 hover:bg-blue-700 text-white h-11">
            {loading ? <><Loader2 size={16} className="mr-2 animate-spin" /> Sending...</> : 'Request Quote'}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default QuoteModal;
